// CURSOR
const cur = document.getElementById('cur');
const cur2 = document.getElementById('cur2');
if (cur && cur2) {
  let mx=0,my=0,r2x=0,r2y=0;
  document.addEventListener('mousemove',e=>{
    mx=e.clientX;my=e.clientY;
    cur.style.left=mx+'px';cur.style.top=my+'px';
  });
  (function tick(){
    r2x+=(mx-r2x)*.1;r2y+=(my-r2y)*.1;
    cur2.style.left=r2x+'px';cur2.style.top=r2y+'px';
    requestAnimationFrame(tick);
  })();
  document.querySelectorAll('a,button,.wcard,.pkg,.svc-row').forEach(el=>{
    el.addEventListener('mouseenter',()=>{cur2.style.width='46px';cur2.style.height='46px';cur2.style.borderColor='rgba(201,168,76,.8)';});
    el.addEventListener('mouseleave',()=>{cur2.style.width='30px';cur2.style.height='30px';cur2.style.borderColor='rgba(201,168,76,.5)';});
  });
}

// SCROLL NAV
const nav=document.getElementById('nav');
if(nav){window.addEventListener('scroll',()=>{nav.classList.toggle('solid',scrollY>50);},{passive:true});}

// MOBILE MENU
const hamburger=document.querySelector('.nav-hamburger');
const mobileMenu=document.getElementById('mobile-menu');
if(hamburger&&mobileMenu){
  const setMenu=(open)=>{
    hamburger.setAttribute('aria-expanded',String(open));
    hamburger.setAttribute('aria-label',open?'Close menu':'Open menu');
    mobileMenu.setAttribute('aria-hidden',String(!open));
    document.body.classList.toggle('menu-open',open);
  };
  hamburger.addEventListener('click',()=>setMenu(hamburger.getAttribute('aria-expanded')!=='true'));
  mobileMenu.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>setMenu(false)));
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&hamburger.getAttribute('aria-expanded')==='true')setMenu(false);});
}

// FORM SUBMIT — designed loading state + double-submit guard (native-POST forms only;
// forms with their own fetch handlers, e.g. [data-apply-form], manage their own states)
document.querySelectorAll('form:not([data-apply-form])').forEach(f=>{
  f.addEventListener('submit',()=>{
    const b=f.querySelector('button[type="submit"]');
    if(!b||b.disabled||b.classList.contains('is-loading'))return;
    b.classList.add('is-loading');
    b.setAttribute('aria-busy','true');
    const label=b.querySelector('span')||b;
    if(!b.dataset.keepLabel){b.dataset.origLabel=label.textContent;label.textContent='Sending';}
    setTimeout(()=>{b.disabled=true;},0);
  });
});

// SCROLL REVEAL
const io=new IntersectionObserver(entries=>{
  entries.forEach((entry,i)=>{
    if(entry.isIntersecting){setTimeout(()=>entry.target.classList.add('in'),i*70);io.unobserve(entry.target);}
  });
},{threshold:.1});
document.querySelectorAll('.reveal').forEach(el=>io.observe(el));

// HOME — RUNORRERY OPERATING CONSOLE (2026-07-15)
// Moved here from an inline <section> <script> after verifying on the real theme that
// Shopify strips inline <script> tags from section markup (scriptCount:0 on render) —
// theme.js is the reliable place for this, matching the SCROLL REVEAL pattern above.
// Every line below reflects something the platform genuinely does — no invented activity.
(function(){
  var feed = document.getElementById('os-feed');
  if (!feed) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var LINES = [
    { t:'06:00', s:'pipeline swept', d:'3 opportunities surfaced, scored, ranked' },
    { t:'06:12', s:'outreach drafted', d:'personalized on a real detail, queued for approval' },
    { t:'06:14', s:'reviewer verified', d:'facts checked, voice checked, consent checked — pass', ok:true },
    { t:'06:31', s:'invoice watched', d:'payment reminder scheduled, nothing sent unreviewed' },
    { t:'07:00', s:'deadline sentinel', d:'2 bids due this week, flagged with days remaining' },
    { t:'07:30', s:'morning brief compiled', d:'revenue, risk, and the one thing to do first', ok:true },
    { t:'08:05', s:'approval granted', d:'one click, the day’s work ships' }
  ];
  function render(line){
    var p = document.createElement('p');
    p.className = 'os-line' + (line.ok ? ' os-line--ok' : '');
    p.innerHTML = '<span class="os-t">' + line.t + '</span><span class="os-k">' + line.s + '</span> · ' + line.d;
    return p;
  }
  if (reduced || !('IntersectionObserver' in window)) {
    feed.innerHTML = '';
    LINES.forEach(function(l){ feed.appendChild(render(l)); });
    return;
  }
  var started = false;
  function typeLine(i){
    if (i >= LINES.length) {
      var caret = document.createElement('span');
      caret.className = 'os-caret';
      feed.appendChild(caret);
      setTimeout(function(){ feed.innerHTML=''; typeLine(0); }, 9000);
      return;
    }
    var line = LINES[i];
    var p = render(line);
    var full = p.innerHTML;
    p.innerHTML = '<span class="os-t">' + line.t + '</span>';
    feed.appendChild(p);
    var rest = document.createElement('span');
    p.appendChild(rest);
    var text = line.s + ' · ' + line.d;
    var j = 0;
    var iv = setInterval(function(){
      j += 2;
      rest.textContent = text.slice(0, j);
      if (j >= text.length) {
        clearInterval(iv);
        p.innerHTML = full;
        setTimeout(function(){ typeLine(i + 1); }, 420);
      }
    }, 14);
  }
  var osIo = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (e.isIntersecting && !started) {
        started = true;
        feed.innerHTML = ''; // clear the <noscript> fallback text node
        typeLine(0);
        osIo.disconnect();
      }
    });
  }, { threshold: .35 });
  osIo.observe(feed);
})();
